import b from 'b_';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import React from 'react';

import Checkbox from '../checkbox/checkbox';
import Text from '../text/text';

import { attributeFilterPropType } from './utils';

class AttributeFilterTypeEnum extends React.Component {
    static propTypes = {
        available: attributeFilterPropType,
        filter: attributeFilterPropType,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    };

    static defaultProps = {
        value: [],
    };

    onCheckboxChange = (e, index) => {
        const { filter, onChange, value } = this.props;
        const {
            target: { checked },
        } = e;

        const currentOption = filter.variants[index].slug;
        const filterValue = Array.isArray(value) ? value : [value];

        let newCheckedOptions;

        if (checked) {
            newCheckedOptions = [...filterValue, currentOption];
        } else {
            newCheckedOptions = filterValue.filter((option) => option !== currentOption);
        }

        onChange(newCheckedOptions.length === 0 ? undefined : newCheckedOptions);
    };

    render() {
        const { available, filter, value } = this.props;
        const isAnyChecked = filter.variants.some(({ slug }) => value.includes(slug));

        return (
            <div className={b('attribute', 'filter', { type: 'enum' })}>
                <div className="attribute__filter-title">
                    <Text weight={Text.WEIGHT.M}>{filter.name}</Text>
                </div>
                {filter.variants.map((variant, optionIndex) => {
                    const checked = value.includes(variant.slug);
                    const disabled = !(available && available.variants.some(({ slug }) => variant.slug === slug));

                    return (
                        <Checkbox
                            checked={checked}
                            disabled={disabled && !isAnyChecked}
                            key={variant.slug}
                            onChange={(e) => this.onCheckboxChange(e, optionIndex)}
                            value={variant.slug}
                        >
                            <Text>{variant.name}</Text>
                        </Checkbox>
                    );
                })}
            </div>
        );
    }
}

export default React.memo(AttributeFilterTypeEnum, (prevProps, nextProps) => {
    return (
        isEqual(prevProps.value, nextProps.value) &&
        isEqual(prevProps.available, nextProps.available) &&
        isEqual(prevProps.filter, nextProps.filter)
    );
});
